require('isomorphic-fetch'); // fetch is global

const log = {
    debug: console.debug.bind(console),
    info: console.log.bind(console),
    error: console.error.bind(console),
};

export type Options = Omit<RequestInit, 'body' | 'credentials' | 'method' | 'window'>;

export async function callApi<ReturnType = any, BodyType = any>(method: 'GET' | 'PUT' | 'POST' | 'DELETE', endpoint: string, body?: BodyType, options?: Options): Promise<ReturnType> {
    const headers = new Headers(options?.headers || {});

    log.debug(`${method} ${endpoint}`);

    // Catch-all in case an undefined value gets converted into a string.
    // Wouldn't normally expect this word to appear in a customer URL.
    if (/undefined/.test(endpoint)) {
        throw new Error(`Unexpected URL: ${endpoint}`);
    }

    // Convert objects into JSON, if necessary
    let fetchBody: BodyInit | null;
    if (typeof body !== 'string' && !(body instanceof FormData)) {
        headers.set('Content-Type', 'application/json');
        fetchBody = JSON.stringify(body);
    }
    else {
        fetchBody = body;
    }

    // Enable same-origin so cookies can be exchanged (Unless explicitly set to 'omit')
    const credentials = "same-origin";

    const response = await fetch(endpoint, { ...options, method, headers, credentials, body: fetchBody });
    if (response.status >= 400) {
        throw new Error(`Error ${response.status}`);
    }

    // All our calls return status code 200.
    // Successful calls have a 'result'; failed calls have an 'err'
    // But note that the content API actually uses 'error' instead of 'err'
    const data = await response.json();
    const e = data.err || data.error;
    if (e) {
        log.error(`Failed request: ${method} ${endpoint} -`, e);
        throw new Error(e);
    }
    else {
        return data.result as ReturnType;
    }
}
